import type { BlockSpeechBubble } from '@dreamstack/payload/src/payload-types'
import type { FunctionComponent } from 'react'

const SpeechTriangle: FunctionComponent = () => (
  <div className="z-index[-10] -translate-y-1/2 -rotate-90 left-[15px] w-0 h-0 border-b-accentroGray-full border-b-[67px] border-l-[67px] border-l-transparent absolute md:left-auto md:right-[15px] md:bottom-[32px] md:rotate-45 md:-translate-y-full md:translate-x-1/2" />
)
export const DarkSpeechBubble: FunctionComponent<
  React.PropsWithChildren<{
    block: BlockSpeechBubble
  }>
> = ({ block }) => {
  const textField = block.text

  return (
    <div className="relative pb-px-32 md:mr-px-32 md:pb-0">
      <div className="bg-accentroGray-full text-accentroWhite-full flex items-center flex-nowrap p-px-24 pb-px-32 md:p-px-40 md:pb-px-48 w-full">
        <p className="text-px-20 leading-px-30 md:text-px-28 md:leading-px-42">
          &ldquo;{textField}&rdquo;
        </p>
      </div>
      <SpeechTriangle />
    </div>
  )
}
